import axios from "axios";
import { operationLogUrl, SESSION_STORAGE_KEY_MAP } from "./constant";
import { getAuthToken, isWechatMiniProgramEnv } from "./common";

export const logOperation = (data: any) => {
  data.opSource = sessionStorage.getItem(SESSION_STORAGE_KEY_MAP.AUTH_TOKEN) ? 'employee' : 'customer';
  data.opCause =  (window as any).currentCampaignId || '';
  console.log("Operation: ", "Data: ", data);
   return axios(operationLogUrl, {
    method: "POST",
    headers: {
      Authorization: getAuthToken(),
      "Content-Type": "application/json",
      Source: isWechatMiniProgramEnv() ? "miniprogram" : "non-mini",
    },
    data,
  })
};


export const getShoppingSkus = (ids: Array<number>, cartData: any) => {
  const skus: any = [];
  const map = new Map();
  const activityData = cartData.activity;
  const exchangeData = cartData.exchange;
  if (activityData) {
    const productGroup = activityData.productGroup;
    productGroup?.forEach((group: any) => {
      group.cartItems?.forEach((item: any) => {
        map.set(item.id, item.sku);
      });
    });
  }
  if (exchangeData) {
    const productGroup = exchangeData.productGroup;
    productGroup?.forEach((group: any) => {
      group.cartItems?.forEach((item: any) => {
        map.set(item.id, item.sku);
      });
    });
  }
  ids.forEach((id) => {
    skus.push(map.get(id));
  });
  return skus;
};